import { createAction, props } from '@ngrx/store';
import { GenesysCloudUser } from '../models/user.model';
import { withGenesysCloudStoreNameSpace } from '../../common/action-namespace';

const withNameSpace = withGenesysCloudStoreNameSpace('Users');

export const initializeModule = createAction(
  withNameSpace('Initialize module')
);

export const loadActualUser = createAction(
  withNameSpace('Load actual user')
);

export const actualUserLoaded = createAction(
  withNameSpace('Actual user loaded'),
  props<{ user: GenesysCloudUser }>()
);

export const loadUserDetails = createAction(
  withNameSpace('Load user details'),
  props<{ userId: string }>()
);

export const userLoaded = createAction(
  withNameSpace('User loaded'),
  props<{ user: GenesysCloudUser }>()
);
